var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('a-icon',{staticClass:"mr8",attrs:{"type":_vm.type}}),_vm._v(" "+_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }